/*
 * @Descripttion:
 * @version:
 * @Author: wangluyao
 * @Date: 2023-06-28 15:14:04
 * @LastEditors: wangluyao
 * @LastEditTime: 2023-07-11 10:08:03
 */
import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

const dashboard: AppRouteModule = {
  path: '/dashboard',
  name: 'Dashboard',
  component: LAYOUT,
  redirect: '/dashboard/workbench',
  meta: {
    orderNo: 100,
    icon: 'ant-design:dashboard-outlined',
    title: t('routes.dashboard.dashboard'),
  },
  children: [
    // {
    //   path: 'analysis',
    //   name: 'Analysis',
    //   component: () => import('/@/views/dashboard/analysis/index.vue'),
    //   meta: {
    //     // affix: true,
    //     title: t('routes.dashboard.analysis'),
    //   },
    // },
    {
      path: 'workbench',
      name: 'Workbench',
      component: () => import('/@/views/dashboard/workbench/index.vue'),
      meta: {
        // affix: true,
        title: t('routes.dashboard.workbench'),
      },
    },
  ],
};

export default dashboard;
